import { useTranslation } from 'react-i18next';

export default () => {
  const { t } = useTranslation();
  return (
    <div className="h-[32px] bg-primaryBgColor text-[14px] text-secondaryTextColor border-b-[1px] border-borderColor flex items-center z-10 sticky top-0 left-0 right-0">
      <div className="flex-1">{t('Account.address')}</div>
      <div className="flex-1 text-center">{t('Account.balance')}</div>
      <div className="flex-1 text-right">%</div>
    </div>
  );
};
